import _styled from "styled-components";
import type { SanityPageBuilderCustomerIoFormSection, SanityPageBuilderSection } from "@ouster/shared";
import { CustomerIoFormBlockView } from "~/features/blocks/inventory/customer-io-form";
import { SanityMediaFigure, hasRenderableSanityMedia } from "~/features/sanity/page-builder/sections/media-figure";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderCustomerIoFormSection;
  };
};
export function SanityCustomerIoFormSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const disclaimer = sectionContent.disclaimer?.length ? <_StyledSanityRichText value={sectionContent.disclaimer} /> : undefined;
  const successMessageText = sectionContent.successMessageText?.length ? <SanityRichText value={sectionContent.successMessageText} /> : undefined;
  const successMessageImage = hasRenderableSanityMedia(sectionContent.successMessageImage) ? <SanityMediaFigure media={sectionContent.successMessageImage} sizes="lg:50vw" /> : undefined;
  return <CustomerIoFormBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} description={sectionContent.description} disclaimer={disclaimer} eventMetadata={sectionContent.eventMetadata} eventName={sectionContent.event?.eventName} fields={sectionContent.fields} formName={sectionContent.formName} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} layout={sectionContent.layout} mode={sectionSettings?.mode || "light"} privacyCheckboxLabel={sectionContent.privacyCheckboxLabel} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} submitLabel={sectionContent.submitLabel} successMessage={sectionContent.successMessage} successMessageImage={successMessageImage} successMessageText={successMessageText} theme={sectionSettings?.theme || "white"} />;
}
var _StyledSanityRichText = /*#__PURE__*/_styled(SanityRichText).withConfig({
  displayName: "customer-io-form___StyledSanityRichText",
  componentId: "sc-10oe9ic-0"
})({
  "fontSize": "1.33rem",
  "--tw-text-opacity": "1",
  "color": "rgb(92 92 92 / var(--tw-text-opacity))"
});